module.exports = __webpack_public_path__ + "img/web-farm-logo.svg";